import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { SidebarService } from "./sidebar.service";
import { ConfigModulosService } from "../../pages/full-pages/configmodulos/configmodulos.service";
import { ConfigModulos } from "../../models/configmodulos.model";
import { AuthService } from "../auth/auth.service";
import { Router } from "@angular/router";
import { Permission, hasPerm } from "../auth/permission.enum";
import { AbTenant } from "app/abstract/full-pages/admin/tenant.abstract";
import { Subject, takeUntil } from "rxjs";
import { MenuItem } from "./menu-item";
import { ConfiguracoesService } from "app/pages/full-pages/configuracoes/configuracoes.service";
import { Configuracoes } from "app/models/configuracoes.model";
import { AbPostHog } from "app/abstract/services/posthog.abstract";
import { PostHogEventEnum } from "enums/posthog-event.enum";

declare let $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  tooggle: boolean = true;
  logoHeader;
  logoHeaderReduzido;
  logoPadrao = "assets/img/logo.png";
  logoPadraoReduzido = "assets/img/logo_min.png";
  menuSidebar: MenuItem[] = [];
  flagNovoFluxoApp: boolean = true;

  private readonly destroy$ = new Subject();

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private authService: AuthService,
    private tenantService: AbTenant,
    private configService: ConfiguracoesService,
    private configModulosService: ConfigModulosService,
    public sidebarService: SidebarService,
    private posthog: AbPostHog
  ) { }

  ngOnInit() {
    $.getScript("./assets/js/app-sidebar.js");
    this.getLogo();

    const tenant = this.tenantService.getTenantStorage();
    if (hasPerm(Permission.CONFIGURACOES_READ) && tenant) {
      this.configModulosService.getConfigModulos().pipe(takeUntil(this.destroy$)).subscribe((configModulos: ConfigModulos) => {
        this.configModulosService.saveConfigModulosStorage(configModulos);
        this.sidebarService.createRoutes();
      }, () => {
        this.sidebarService.createRoutes();
      });
    } else {
      this.sidebarService.createRoutes();
    }

    this.sidebarService.menu.pipe(takeUntil(this.destroy$)).subscribe((list: MenuItem[]) => {
      this.menuSidebar = [];
      this.menuSidebar = list;
      this.configService.getReloadConfiguracoes().pipe(takeUntil(this.destroy$)).subscribe((config: Configuracoes) => {
        if (config)
          this.flagNovoFluxoApp = config.configPrevisaoVisita.novoFluxoApp;
        else
          this.flagNovoFluxoApp = true;
      });
    });
  }

  event() {
    this.tooggle = !this.tooggle;
  }

  getLogo() {
    const user = this.authService.getUsuarioStorage();
    if (!user || user.contas.length > 0 || user.integrador) {
      const logo = sessionStorage.getItem("logoHeader");
      const logo_min = sessionStorage.getItem("logoHeaderReduzido");
      if (logo && logo != 'undefined') {
        const url = sessionStorage.getItem("logoHeader").startsWith("http");
        const logoAux = (url ? "" : "data:image/jpg;base64,") + sessionStorage.getItem("logoHeader");
        if (this.logoHeader !== logoAux) {
          this.logoHeader = logoAux;
        }
      }

      if (logo_min && logo_min != 'undefined') {
        const url = sessionStorage.getItem("logoHeaderReduzido").startsWith("http");
        const logoAux_min = (url ? "" : "data:image/jpg;base64,") + sessionStorage.getItem("logoHeaderReduzido");
        if (this.logoHeaderReduzido !== logoAux_min) {
          this.logoHeaderReduzido = logoAux_min;
        }
      }

      if (this.logoHeader || this.logoHeaderReduzido) {
        if (this.logoHeader && !this.logoHeaderReduzido) {
          this.logoHeaderReduzido = this.logoHeader;
        }

        if (!this.logoHeader)
          this.logoHeader = this.logoPadrao;

        return true;
      }
    }

    this.logoHeaderReduzido = this.logoPadraoReduzido;
    this.logoHeader = this.logoPadrao;
    return true;
  }

  cleanFilterSessionStorage() {
    this.authService.cleanFilter();
  }

  
  onMenuItemClick(menuItem: MenuItem): void {
    if (menuItem.isExternalLink) return;
    this.posthog.capture(PostHogEventEnum.MENU_CLICADO, {
      item: menuItem.path || menuItem.title
    });
  }

  redirecionar() {
    const user = this.authService.getUsuarioStorage();
    if (user) {

      this.ngZone.run(() => {
        if (user.integrador && this.tenantService.getTenantStorage() == null) {
          this.router.navigate(["/conta/list-conta"]);
        } else if (user.contas.length == 0 && !user.integrador) {
          this.router.navigate(["/integrador/list-integrador"]);
        } else {
          this.router.navigate(["/home"]);
        }
      });
    }
  }

  isIntegrador(): boolean {
    return this.authService.isIntegrador();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
